import { UserRole } from 'shared/types/userRole';
import { AccessManagementColumn } from '../types';
import { StyledTableRow } from './tableRow';
import { useIntl } from 'react-intl';
import { translateRole } from 'shared/domain/user/mapping/toView';
import { ReactElement } from 'react';
import { UserTranslationKeys } from 'intl/keys';

export const roleColumn: AccessManagementColumn = {
  id: 'role',
  label: UserTranslationKeys.managementRole,
  style: { minWidth: '100px' },
};

export function RoleRow({ role }: { role: UserRole }): ReactElement {
  const intl = useIntl();
  return (
    <StyledTableRow key={roleColumn.id}>
      <span>{translateRole(role, intl)}</span>
    </StyledTableRow>
  );
}
